export default {
  comingSoon: { id: 'application_coming_soon' },
}
